import { render, staticRenderFns } from "./InquiryRegisterConfirmPop.vue?vue&type=template&id=2d4b789e&scoped=true&"
import script from "./InquiryRegisterConfirmPop.vue?vue&type=script&lang=js&"
export * from "./InquiryRegisterConfirmPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b789e",
  null
  
)

component.options.__file = "InquiryRegisterConfirmPop.vue"
export default component.exports